module.exports = __webpack_public_path__ + "CheckboxActive___2xZS4.svg";